import React, { useState } from "react";
import Select, { OnChangeValue } from "react-select";
import CreatableSelect from "react-select/creatable";
import * as Commons from "oc-commons/Commons";

export const SelectInput = ({ property }) => {
  const [, forceUpdate] = useState();
  const value = property.get() ?? "";
  const options1 = property.selectOptions ?? [];
  if (!_.isFunction(options1.map)) {
    debugger;
  }
  const options = options1.map((o) => ({ value: o, label: o }));
  const onChange = (newValue: OnChangeValue<any, any>, actionMeta) => {
    console.log("newValue", newValue, actionMeta);
    const v = newValue.value;
    const v1 = Commons.isEmpty(v) ? null : v;
    forceUpdate(property.set(v1));
    APP.sceneNode.callDebouncedUpdateSceneOn(property.node);
  };
  const optionValue = options.find((o) => o.value == value);
  const clearable = property.clearable ?? false;
  if (property.createable) {
    return (
      <CreatableSelect
        className="comboSelectInput"
        classNamePrefix="comboSelectInput"
        isClearable={clearable}
        value={optionValue}
        onChange={onChange}
        options={options}
      />
    );
  }
  return (
    <Select
      className="comboSelectInput"
      classNamePrefix="comboSelectInput"
      isClearable={clearable}
      value={optionValue}
      onChange={onChange}
      options={options}
    />
  );
};
